// Runtime polyfills for WebKit and Android System WebView versions the native
// app still runs on (React Native 0.77 allows iOS 15.1; Android WebView updates
// lag on some devices). Vite transpiles syntax to its default targets but does
// not add missing APIs. Imported first by src/index.tsx, before any chunk that
// could use these. Seen in production: "Object.hasOwn is not a function" on an
// Android 11 WebView unmounted a route.

export function installRuntimePolyfills(): void {
  if (typeof Object.hasOwn !== "function") {
    Object.defineProperty(Object, "hasOwn", {
      configurable: true,
      writable: true,
      // Like the native API, null and undefined throw a TypeError.
      value: (target: object, property: PropertyKey): boolean =>
        Object.prototype.hasOwnProperty.call(target, property),
    });
  }

  if (typeof Array.prototype.at !== "function") {
    // eslint-disable-next-line no-extend-native -- standard method, added only where the engine lacks it
    Object.defineProperty(Array.prototype, "at", {
      configurable: true,
      writable: true,
      value: function at<T>(this: readonly T[], index: number): T | undefined {
        const length = this.length;
        const relativeIndex = Math.trunc(index) || 0;
        const resolvedIndex = relativeIndex < 0 ? length + relativeIndex : relativeIndex;
        return resolvedIndex < 0 || resolvedIndex >= length ? undefined : this[resolvedIndex];
      },
    });
  }
}

// Also at module evaluation: ESM evaluates imports in order before the entry
// body runs, so being the first import guarantees the APIs exist for every
// other module. The named export keeps the import explicit (the repository
// disallows side-effect-only imports) and idempotent.
installRuntimePolyfills();
